var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8679 2.98011L10.3187 7.5L14.8679 12.0199C14.9501 11.848 15 11.658 15 11.4551V3.54492C15 3.34198 14.9501 3.15199 14.8679 2.98011ZM13.6816 2.22656H1.31836C1.11542 2.22656 0.92543 2.27646 0.753545 2.35869L6.56789 8.14374C7.08199 8.65784 7.91801 8.65784 8.43211 8.14374L14.2465 2.35869C14.0746 2.27646 13.8846 2.22656 13.6816 2.22656ZM0.132129 2.98011C0.0498926 3.15199 0 3.34198 0 3.54492V11.4551C0 11.658 0.0498926 11.848 0.132129 12.0199L4.68132 7.5L0.132129 2.98011Z",
    fill: "#D0D4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69714 8.12141L9.0534 8.76515C8.19679 9.62177 6.80293 9.62177 5.94632 8.76515L5.30261 8.12141L0.753418 12.6413C0.925303 12.7235 1.11529 12.7734 1.31823 12.7734H13.6815C13.8845 12.7734 14.0744 12.7235 14.2463 12.6413L9.69714 8.12141Z",
    fill: "#D0D4E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.f9ac295f5825c59ce4a20ef68149ddf9.svg";
export { ForwardRef as ReactComponent };